import { api } from '@api'
import { BillingBatchFilters } from '@types'

type Params = {
  filters?: BillingBatchFilters
}

const getBillingBatch = async (params: Params) => {
  try {
    const { filters } = params
    const response = await api.get('/billing-batch', {
      params: {
        ...filters,
        orderBy: 'DESC',
      },
    })
    return response.data
  } catch (error) {
    console.error('Error al obtener los lotes:', error)
    throw error
  }
}

export { getBillingBatch }
